import React from "react";
import { connect } from "react-redux";
import { ReduxState, ReduxDispatch } from "../../ducks/reducers";
import {
    ShowLogo,
    ShowBackNavigationWithRoute,
    SetShowBackNavigation,
    SetHeader,
} from "../../ducks/common";
import { RouteComponentProps, RouterProps } from "react-router";
import SwipeableViews from "react-swipeable-views";
import AccountPage from "./AccountPage";
import ChevronLeftIcon from "material-ui-icons/ChevronLeft";
import ChevronRightIcon from "material-ui-icons/ChevronRight";
import {
    getAllAccounts,
    getAllAccountsData,
    Accounts,
    getAllAccountsArray,
} from "../../ducks/account";
import { Button, WithStyles } from "material-ui";
import FullPageSpinner from "../../components/FullPageSpinner/FullPageSpinner";
import logger from "../../util/logger";
import { lowToHigh } from "util/utils";
import { AccountDto } from "util/DTOs/AccountDtos";

const sortAccounts = (a: AccountDto, b: AccountDto) => {
    return lowToHigh(a.balance, b.balance);
};

const styles = {
    container: {
        paddingRight: 20,
        paddingLeft: 20,
        marginBottom: 60,
    },
    subheadingWeight: {
        fontWeight: "200",
    },
    centerText: {
        textAlign: "center",
    },
    rightText: {
        textAlign: "right",
    },
    flexRoot: {
        display: "flex",
        width: "100%",
    },
    flexItem: {
        flex: 1,
        whiteSpace: "nowrap",
    },
} as React.CSSProperties;

interface IAccountsPageProps extends RouteComponentProps<{ id?: number }> {}
interface IAccountsPageReduxProps {
    accountData: AccountDto[]; //Accounts;
}
interface IAccountsPageDispatchProps {
    setHeaderValue: (header: string) => void;
    showLogo: (show: boolean) => void;
    setBackButton: (route: string) => void;
    hideBackButton: () => void;
    getAccountsData: () => Promise<void>;
}

interface AccountsPageState {
    currentIndex: number;
    loading: boolean;
}

type AccountsPageProps = IAccountsPageProps &
    IAccountsPageReduxProps &
    IAccountsPageDispatchProps &
    RouterProps &
    WithStyles<
        | "container"
        | "subheadingWeight"
        | "centerText"
        | "rightText"
        | "flexRoot"
        | "flexItem"
        | "flatButton"
    >;

class AccountsPage extends React.Component<
    AccountsPageProps,
    AccountsPageState
> {
    constructor(props: AccountsPageProps) {
        super(props);
        this.state = { currentIndex: 0, loading: true };
    }
    componentDidMount() {
        this.props.setBackButton("/");
        this.props
            .getAccountsData()
            .then(() => {
                this.setState({ ...this.state, loading: false });
            })
            .catch((err) => {
                logger.error(err);
                this.setState({ ...this.state, loading: false });
            });

        this.props.setHeaderValue("Tilit");
        window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps: AccountsPageProps) {
        if (nextProps.match.params.id) {
            let index = nextProps.accountData.findIndex((item) => {
                return Number(item.id) === Number(nextProps.match.params.id);
            });

            if (index !== -1 && this.state.currentIndex !== index) {
                this.setState({ currentIndex: index });
                this.setHeaderValue(index);
            }
        }
    }

    componentWillUnmount() {
        this.props.hideBackButton();
        this.props.setHeaderValue("");
    }

    setIndex(index: number) {
        if (this.props.match.params.id) {
            this.props.history.replace("/account");
        }

        const keys = this.props.accountData;
        if (
            index >= keys.length ||
            index < 0 ||
            this.state.currentIndex === index
        ) {
            return;
        }
        this.setState({ currentIndex: index });
        this.setHeaderValue(index);
    }

    setHeaderValue = (index: number) => {
        const acc = this.props.accountData[index];

        if (acc) {
            this.props.setHeaderValue(acc.accountName || "Talletustili");
        }
    };

    render() {
        const accounts = this.props.accountData.map((item, index) => {
            return (
                <AccountPage
                    key={item.id}
                    id={item.id}
                    {...this.props}
                    isVisibleView={index === this.state.currentIndex}
                />
            );
        });

        return (
            <div className="page-container">
                <FullPageSpinner loading={this.state.loading} />
                <SwipeableViews
                    index={this.state.currentIndex}
                    onChangeIndex={(i: number) => this.setIndex(i)}
                >
                    {(accounts && accounts.length > 0 && accounts) || (
                        <div className="centered-message-container">
                            <h2 className="hypodgrey">EI TILEJÄ</h2>
                        </div>
                    )}
                </SwipeableViews>
                {this.state.currentIndex > 0 && (
                    <div id="gallery-prev-btn">
                        <Button
                            aria-label="Edellinen tili"
                            onClick={() =>
                                this.setIndex(this.state.currentIndex - 1)
                            }
                        >
                            <ChevronLeftIcon
                                style={{
                                    height: "48px",
                                    width: "48px",
                                    color: "rgba(0,0,0,0.5)",
                                }}
                            />
                        </Button>
                    </div>
                )}
                {/* {this.state.currentIndex < keys.length - 1 && ( */}
                {this.state.currentIndex <
                    this.props.accountData.length - 1 && (
                    <div id="gallery-next-btn">
                        <Button
                            aria-label="Seuraava tili"
                            onClick={() =>
                                this.setIndex(this.state.currentIndex + 1)
                            }
                        >
                            <ChevronRightIcon
                                style={{
                                    height: "48px",
                                    width: "48px",
                                    color: "rgba(0,0,0,0.5)",
                                }}
                            />
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (
    state: ReduxState,
    props: AccountsPageProps
): IAccountsPageReduxProps => {
    let accountsData = getAllAccountsArray(state) || [];

    accountsData = accountsData.sort(sortAccounts);
    return {
        accountData: accountsData,
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IAccountsPageDispatchProps => {
    return {
        setHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        showLogo: (show: boolean) => {
            return dispatch(ShowLogo(show));
        },
        setBackButton: (route: string) => {
            dispatch(ShowBackNavigationWithRoute(route));
        },
        hideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
        getAccountsData: async () => {
            await dispatch(getAllAccounts());
        },
    };
};

export default connect<
    IAccountsPageReduxProps,
    IAccountsPageDispatchProps,
    IAccountsPageProps
>(
    mapStateToProps,
    mapDispatchToProps
)(AccountsPage);



// WEBPACK FOOTER //
// ./src/views/account/AccountsPage.tsx